import './ScreenshotDisplay.css';

const ScreenshotDisplay = ({ screenshot, onCancel, onSolve, isVisible, showOnlyCancel, isSolving }) => {
  if (!screenshot) return null;

  return (
    <div className="screenshot-container">
      {!showOnlyCancel && isVisible && (
        <img 
          src={screenshot} 
          alt="Скриншот с камеры"
          className="screenshot-image"
        />
      )}
      <div className="buttons-container">
        {isVisible && !isSolving && (
          <button
            onClick={onSolve}
            className="action-button solve-action"
          >
            Solve
          </button>
        )}
        <button
          onClick={onCancel}
          className="action-button cancel-action"
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ScreenshotDisplay; 